<div class="cell auto" *ngIf="parameters">
    <form #vatParametersForm="ngForm">
        <kiwi-parameters-tab-content-header [titleLabelKey]="'parameters.vat.title'"
                                            [saveDisabled]="areParametersReadonly()"
                                            (saved)="updateParameters()">
        </kiwi-parameters-tab-content-header>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p [i18nKey]="'parameters.vat.description'"></p>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <table class="_tableColor">
            <tbody>
                <tr>
                    <td [i18nKey]="'parameters.vat.ingredients.purchase'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.ingredientsPurchaseVAT"
                                               name="ingredientsPurchaseVAT"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
                <tr>
                    <td [i18nKey]="'parameters.vat.dishes.sales'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.dishesSalesVAT"
                                               name="dishesSalesVAT"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
                <tr>
                    <td [i18nKey]="'parameters.vat.wine.bottles.purchase'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.wineBottlesPurchaseVAT"
                                               name="wineBottlesPurchaseVAT"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
                <tr>
                    <td [i18nKey]="'parameters.vat.wine.bottles.sales'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.wineBottlesSalesVAT"
                                               name="wineBottlesSalesVAT"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
                <tr>
                    <td [i18nKey]="'parameters.vat.layout.purchase'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.layoutPurchaseVAT"
                                               name="layoutPurchaseVAT"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
                <tr>
                    <td [i18nKey]="'parameters.vat.layout.sales'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.layoutSalesVAT"
                                               name="layoutSalesVAT"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
                <tr>
                    <td [i18nKey]="'parameters.vat.other.operation.revenue'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.otherOperationRevenueVAT"
                                               name="otherOperationRevenueVAT"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
                <tr>
                    <td [i18nKey]="'parameters.vat.other.operating.charges'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.otherOperatingChargesVATRate"
                                               name="otherOperatingChargesVATRate"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
                <tr>
                    <td [i18nKey]="'parameters.vat.external.loads'"></td>
                    <td>
                        <kiwi-percentage-input [(ngModel)]="parameters.externalLoadsVAT"
                                               name="externalLoadsVAT"
                                               [disabled]="areParametersReadonly()">
                        </kiwi-percentage-input>
                    </td>
                </tr>
            </tbody>
        </table>
    </form>
</div>
